// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-6fa700e1]{background:#fff;border:none;cursor:pointer;padding:6px 10px;position:absolute;right:15px;top:20px;z-index:2}.close-icon[data-v-6fa700e1]{color:#5bac26;font-size:16px}@media (min-width:544px){button[data-v-6fa700e1]{padding:8px 12px;right:20px}.close-icon[data-v-6fa700e1]{font-size:26px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
